// @flow

const getStyle = (el: any, prop: string): any => {
    return (typeof getComputedStyle !== "undefined"
        ? getComputedStyle(el)
        : el.currentStyle)[prop];
};

export default getStyle;
